import App from '../App';
import { getLocalUSDZBlob } from './usdz/UsdScene';
import { uploadContent } from '../eaiws-plugins/FileStorage';

import { safari, iOSQuicklookArAvailable } from '@egr/xbox/utils/UserAgent';
import { withProgress } from '@egr/xbox/progress-manager/ProgressManager';

import { BoundingBox, SceneElement } from '@egr/wcf/modules/core/mdl';

import { RoomElement } from '@egr/room/modules/mdl/RoomElement';
import { Measure } from '@egr/room/modules/mdl/Measure';

export class ShareActions {
    constructor(protected app: App) {
        this.openUSDZinAR = this.openUSDZinAR.bind(this);
    }

    /**
     * Safari accepts Blob-URL so the upload is skipped here, but for other browsers the
     * content must be served over HTTP with the appropriate MIME-type (model/vnd.usdz+zip)
     */
    @withProgress('open USDZ in AR')
    public async openUSDZinAR(scaleUdsz: boolean = false): Promise<void> {
        if (!iOSQuicklookArAvailable) {
            return;
        }

        this.app.viewManager.arStarted = true;

        let elements: Array<SceneElement> = [];

        elements = this.app.coreApp.model.elements.filter((pElement) => {
            if (
                (pElement instanceof RoomElement && pElement.type === 'CameraPath') ||
                pElement instanceof Measure ||
                (pElement instanceof RoomElement && pElement.type === 'Text')
            ) {
                return (null);
            }

            return (pElement);
        });

        let scale: number = 1;

        if (scaleUdsz) {
            const boundingBox: BoundingBox = BoundingBox.FromElements(elements);
            const originalHeight: number = boundingBox.max.y - boundingBox.min.y;
            scale = 0.2 / originalHeight;
        } else {
            elements = await this.app.kompanSettingsManager.getOFMLElements(this.app, ['pec']);
        }

        const usdExport: Blob = await getLocalUSDZBlob(
            this.app.coreApp.model,
            { scale },
            elements
        );

        const url: string = safari ?
            URL.createObjectURL(usdExport) :
            await uploadContent(this.app.eaiwsSession.baseUrl, 'scene.usdz', await usdExport.arrayBuffer());

        const link: HTMLAnchorElement = document.createElement('a');

        link.style.display = 'none';
        link.href = url;
        link.download = 'scene.usdz';

        document.body.appendChild(link);

        // ar links for IOS have to be marked with "ar" and need to contain an image
        link.rel = 'ar'; // required for IOS
        link.innerHTML = '<img src="w-cf/data/core/textures/fallback.png"/>';
        link.click();

        // clean up (delay to prevent error in IOS)
        setTimeout(() => {
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        });

        this.app.viewManager.arStarted = false;
    }
}